<wbo-edit-page #editPage [title]="model.data.companyName">
    <fui-formation-group-template *formationGroup="{title: 'wbo.company-details.edit.formation.details', formControlNames: ''}">
        <wbo-company-details-edit-details></wbo-company-details-edit-details>
    </fui-formation-group-template>
    <fui-formation-group-template *formationGroup="{title: 'wbo.company-details.edit.formation.receipt-configuration', formControlNames: 'receiptConfiguration'}">
        <wbo-company-details-edit-additional-information></wbo-company-details-edit-additional-information>
    </fui-formation-group-template>
    <fui-formation-group-template *formationGroup="{title: 'wbo.company-details.edit.formation.taxes-receipt', formControlNames: ''}">
        <wbo-company-details-edit-taxes-receipt></wbo-company-details-edit-taxes-receipt>
    </fui-formation-group-template>
</wbo-edit-page>
